import React from 'react';
import {SectionTitleStyled, TestimonialContainerStyled} from "../../../styled/HomeContent";
import {useTheme} from "../Theme/ThemeContext"
import RenderTestimonialData from "./RenderData";
import { useTestimonials } from '../../../hooks/useTestimonials';

const Testimonials = () => {
    const {themeName} = useTheme()
    const testimonials = useTestimonials();

    return (
        <TestimonialContainerStyled theme={themeName}>
            <SectionTitleStyled theme={themeName}>Testimonials</SectionTitleStyled>

            <RenderTestimonialData data={testimonials} />

        </TestimonialContainerStyled>
    )
};

export default Testimonials;
